import React, { useState } from "react";
import { Table } from "reactstrap";
import Button from '@material-ui/core/Button';
import { stateConvert } from "utils/stateAbbreviation";
import { TableContainer } from "styles/components/AccordionTable";
import UploadDummy from "assets/images/UploadDummy.png";
import TooltipMaterial from "@material-ui/core/Tooltip";
import * as moment from "moment";
import CommentBoxModal from "components/CommentBoxModal";
import { UploadSpec } from "styles/pages/request-orders";
import DownloadInvoiceIcon from "assets/svg/DownloadInvoiceIcon";
import InfoIcon from "assets/svg/InfoIcon"
import { useText } from "locales/useGetText";
import MixPalletDetailsModal from "components/MixPalletDetailsModal";
import { getLoggedInUserCountry } from "helpers";

const AccordionTable = (props) => {
  const locale = useText("manageOrder");
  const userCountry = getLoggedInUserCountry?.() || "USA";

  const [accordionExpand, setAccordionExpand] = useState([])

  const [commentModal, setCommentModal] = useState(false)
  const commentToggleModal = () => setCommentModal(!commentModal)
  const [getItem, setItem] = useState();

  const [mixModalOpen, setMixModalOpen] = useState(false);
  const [selectedMixOrder, setSelectedMixOrder] = useState(null);

  const handleViewMixPallet = (data) => {
    setSelectedMixOrder(data);
    setMixModalOpen(true);
  };
  const cancelOrderFunction = items => {
    commentToggleModal()
    setItem(items)
    // props.cancelOrderCallback(items)
  }

  const setAccordionFunction = (refNo, type) => {
    if (type === 'remove') {
      let initialArray = accordionExpand
      let indexVal = initialArray.indexOf(refNo)
      let finalArray = initialArray.filter((data, index) => index !== indexVal)
      setAccordionExpand(finalArray)
    } else if (type === 'add') {
      if (!accordionExpand.includes(refNo)) {
        let initialArray = accordionExpand
        initialArray.push(refNo)
        let finalArray = JSON.parse(JSON.stringify(initialArray))
        setAccordionExpand(finalArray)
      }
    }
  }

  const orderType = (items) => {
    let totalQuantity = items?.quantityDetails?.totalQuantity

    if (items?.requestType === 'PickUp') return totalQuantity + ', ' + 'Pickup'

    let material = items?.palletDetails?.material
    let condition
    if (items?.palletDetails?.condition?.length !== 1) {
      condition = items?.palletDetails?.condition?.join(", ")
    } else {
      if (items?.palletDetails?.condition.length !== 0)
        condition = items?.palletDetails?.condition
    }

    let palletType;
    let moisture = "";
    let size = "";
    let grade = "";
    let LWH
    if (items?.palletDetails?.material !== "WOOD") {
      const length = items?.palletDetails?.length
      const width = items?.palletDetails?.width
      const height = items?.palletDetails?.height
      LWH = length + "x" + width + "x" + height
      // + ", " + material 
      if (condition) {
        condition = condition?.toString()
        condition = condition?.toLowerCase();
        condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

        return totalQuantity + ", " + LWH + "-" + condition
      } else {
        return totalQuantity + ", " + LWH
      }

    } else {
      palletType = items?.palletDetails?.palletType

      if (items?.palletDetails?.size)
        size = ", " + items?.palletDetails?.size

      if (items?.palletDetails?.grade)
        grade = ", " + items?.palletDetails?.grade

      palletType = palletType?.toLowerCase();
      palletType = palletType?.replace(/\b\w/g, c => c.toUpperCase())
      condition = condition?.toString()
      condition = condition?.toLowerCase();
      condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

      if (items?.palletDetails?.newConditionType) {
        let newConditionType
        if (items?.palletDetails?.newConditionType === 'HARDWOOD') newConditionType = '(HW)'
        else if (items?.palletDetails?.newConditionType === 'SOFTWOOD') newConditionType = '(SW)'
        if (newConditionType) condition = `${condition} ${newConditionType}`
      }

      return totalQuantity + "" + size + "" + grade + ", " + palletType + "-" + condition
    }

  }
  const defaultAttachedSpectFiles = (uploadImageStage) => {
    return (
      <div className="col-12 mb-2 max-3-row" style={{ display: "flex" }}>
        {uploadImageStage.map((item, index) => (
          <div className="row mb-1" key={index} style={{ backgroundColor: "" }} onClick={() => {

            generatePdfDocument(item)
          }}>

            <UploadSpec
              className="upload col-12"
            >
              <img
                src={UploadDummy}
                alt="upload Dummy"
                style={{ marginLeft: "2%" }}
              />
              <TooltipMaterial
                placement="top"
                arrow
                title={item}
                enterTouchDelay={0}
              >
                <span onClick={() => {

                  generatePdfDocument(item)
                }}></span>

              </TooltipMaterial>

            </UploadSpec>
          </div>
        ))
        }
      </div >
    );

  }
  const generatePdfDocument = async (imagePath) => {
    const fileUrl = process.env.REACT_APP_API_URL + "/s3/get_file/" + imagePath;
    window.open(fileUrl);
  };

  const downloadPodFiles = (files) => {
    if (files) {
      let res = files.map(data => {
        let fileUrl = process.env.REACT_APP_API_URL + "/s3/get_file/" + data?.fileName;
        window.open(fileUrl);
      })
    }
  }

  const borderStyle = {
    border: "1px solid #E5E5E5",
    padding: "4px 10px 4px",
    whiteSpace: "nowrap",
    borderRadius: "3px",
    backgroundColor: "white",
    display: "flex",
    gap: "5px",
    cursor: "pointer",
    alignItems: "center",
    width: "38px",
    margin: "0 auto"
  }

  return (
    <>
      <TableContainer>
        <Table responsive>
          <thead>
            <tr>
              {props?.headerArr.map((items, index) => (
                <th key={index}>{items}</th>
              ))}
              {props.orderType !== 'createdOrder' ? <th></th> : ""}
            </tr>
          </thead>
          <tbody>
            {props?.tableDataList?.orderLists?.map((items, index) => (
              <>
                <tr className={index % 2 !== 0 ? 'odd-rows set-border' : 'even-rows set-border'}>
                  <td>{items.orderRefNumber}</td>
                  <td>{items.orderId}</td>
                  <td>{items.poNumber}</td>
                  <td>{items.shippingAddress.locationName} - {items?.shippingAddress?.street}</td>
                  <td>{items.shippingAddress?.city}, {stateConvert(items.shippingAddress?.state) || items.shippingAddress?.state}</td>
                  <td>
                    {(items?.mixPalletDetails || items?.multiplePalletCombination) ? (
                      <button
                        type="button"
                        className="view-mix-pallet-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewMixPallet(items);
                        }}
                      >
                        View Mix Pallet
                      </button>
                    ) : (
                      orderType(items)
                    )}
                  </td>
                  <td>{items?.requestType === 'PickUp' ? 'Pickup' : 'Delivery'}</td>
                  {props?.orderType === "All Order" ?
                    <td>{items.requestedDate}</td>
                    :
                    (items.orderStatus === "DELIVERED" || items.orderStatus === "COMPLETED" || items.orderStatus === "PICKEDUP") ?
                      <td >{moment(items.actualDeliveryDate).format("MM/DD/YYYY")}</td> :
                      <td>{(items.orderStatus === "CANCELLED" || items?.orderStatus === "CANCELED") ?
                        (moment(items?.orderCancelDetails?.cancelDate * 1000).format("MM/DD/YYYY")) :
                        (items.orderStatus === "CLAIMED" && items?.ptPostedDetailsDTO?.requestDeliveryDate) ? moment(items?.ptPostedDetailsDTO?.requestDeliveryDate).format("MM/DD/YYYY") : moment(items.requestedDate).format("MM/DD/YYYY")}</td>
                  }
                  {/* to display invoice in completed and all order tabs */}
                  {(props?.orderTabName === "completedOrders") && <td><center>{items?.invoiceId ? items?.invoiceId : 'NA'}</center></td>}
                  {props?.orderType === "All Order" &&
                    <>
                      <td>{items?.orderStatus}</td>
                      {<td><center>{items?.invoiceId ? items?.invoiceId : 'NA'}</center></td>}

                      {(items?.requestType !== 'PickUp' && (items?.orderStatus === "COMPLETED")) &&
                        <td>
                          <div style={borderStyle} onClick={() => {
                            generatePdfDocument(items?.bol)
                          }}>
                            <DownloadInvoiceIcon width={16} height={16} />
                          </div>
                        </td>
                      }
                      {(items?.requestType === 'PickUp' && (items.orderStatus === "COMPLETED")) &&
                        <td>
                          <div style={borderStyle} onClick={() => {
                            downloadPodFiles(items?.pod)
                          }}>
                            <DownloadInvoiceIcon width={16} height={16} />
                          </div>
                        </td>
                      }

                      {(items?.orderStatus === "CANCELLED" || items?.orderStatus === "CANCELED") &&
                        <td>
                          <div style={{ ...borderStyle, border: 'none', backgroundColor: 'transparent' }}>
                            <TooltipMaterial
                              placement="top"
                              arrow
                              title={
                                <>
                                  <p>{locale("canceledBy")} : {items?.orderCancelDetails?.canceledBy}</p>
                                  <p>{locale("dateCanceled")} : {moment(items?.orderCancelDetails?.cancelDate * 1000).format("MM/DD/YYYY")}</p>
                                </>
                              }
                              enterTouchDelay={0}
                            >
                              <span onClick={() => {

                              }}> <p className='print-tag-style' ><InfoIcon /></p></span>
                            </TooltipMaterial>
                          </div>
                        </td>
                      }

                      {(items.orderStatus === "CLAIMED" && items?.requestType !== 'PickUp') && <td className='expand-collapse-class'>
                        {(accordionExpand.includes(items.orderRefNumber)) ?
                          <h4 onClick={() => setAccordionFunction(items.orderRefNumber, 'remove')}><i></i></h4>
                          : <h5 onClick={() => setAccordionFunction(items.orderRefNumber, 'add')}><i></i></h5>
                        }
                      </td>}
                      {(items.orderStatus === "REQUESTED" || items.orderStatus === "ASSIGNED") && <td></td>}
                      <td></td>
                    </>}


                  {props.orderType !== "All Order" &&
                    <>
                      {(items.orderStatus === "CANCELLED" || items?.orderStatus === "CANCELED") && <td>{items?.orderCancelDetails?.canceledBy}</td>}
                      {(items.orderStatus === "CANCELLED" || items?.orderStatus === "CANCELED") && <td>
                        <TooltipMaterial
                          placement="top"
                          arrow
                          title={items?.orderCancelDetails?.comment}
                          enterTouchDelay={0}
                        >
                          <span className={"remark"}>{items?.orderCancelDetails?.comment}</span>
                        </TooltipMaterial>
                      </td>}
                      {(items?.requestType !== 'PickUp' && (items.orderStatus === "COMPLETED")) &&
                        <td>
                          <div style={borderStyle} onClick={() => {
                            generatePdfDocument(items?.bol)
                          }}>
                            <DownloadInvoiceIcon width={16} height={16} />
                          </div>
                        </td>
                      }
                      {(items?.requestType === 'PickUp' && (items.orderStatus === "COMPLETED")) &&
                        <td>
                          <div style={borderStyle} onClick={() => {
                            downloadPodFiles(items?.pod)
                          }}>
                            <DownloadInvoiceIcon width={16} height={16} />
                          </div>
                        </td>
                      }
                    </>
                  }

                  {props.orderType === 'createdOrder' && <td>{items.orderStatus}</td>}

                  {props.orderType === 'createdOrder' && items.orderStatus !== "SHIPPED" && items.orderStatus !== "RESCHEDULED" && <td>
                    <div style={{ "margin-top": "-10px" }}>
                      <Button className="cancel-order" variant="outlined" onClick={() => cancelOrderFunction(items)}>{locale("cancel")}</Button>
                    </div></td>
                  }
                  {props.orderType === 'createdOrder' && items.orderStatus === "SHIPPED" && <td></td>}
                  {props.orderType === 'createdOrder' && items.orderStatus === "RESCHEDULED" && <td></td>}

                  {props.orderType !== "All Order" &&
                    <>
                      {(items.orderStatus === "CLAIMED" && items?.requestType !== 'PickUp') && <td className='expand-collapse-class'>
                        {(accordionExpand.includes(items.orderRefNumber)) ?
                          <h4 onClick={() => setAccordionFunction(items.orderRefNumber, 'remove')}><i></i></h4>
                          : <h5 onClick={() => setAccordionFunction(items.orderRefNumber, 'add')}><i></i></h5>
                        }
                      </td>}
                    </>
                  }
                </tr>

                {accordionExpand.includes(items.orderRefNumber) &&
                  <>
                    <tr className={index % 2 !== 0 ? 'odd-rows order-details-wrapper' : 'even-rows order-details-wrapper'}>
                      {items.orderStatus === "CLAIMED" ? (
                        <td colspan="1">
                          <div>
                            <h6>{locale("claimDate")}</h6>
                            <p>{moment(items?.orderClaimDetails?.claimRaiseDate * 1000).format("MM/DD/YYYY")}</p>
                          </div>
                        </td>
                      ) : (<td colspan="1">
                        <div>
                          <h6>{locale("orderDetails")}</h6>
                          {(items?.mixPalletDetails || items?.multiplePalletCombination) ? (
                            <button
                              type="button"
                              className="view-mix-pallet-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleViewMixPallet(items);
                              }}
                            >
                              View Mix Pallet
                            </button>
                          ) : (
                            <p>{orderType(items)}</p>
                          )}
                        </div>
                      </td>)}
                      {/* {items.orderStatus === "CLAIMED" && (<td colspan="1">
                        <div>
                          <h6 style={{ whiteSpace: 'nowrap' }}>{locale("claimReason")}</h6>
                          <p>{items?.orderClaimDetails?.claimType}</p>
                        </div>
                      </td>)} */}
                      {items.orderStatus === "CLAIMED" &&
                        <>
                          {/* <td colspan="1">
                            <div>
                              <h6>{locale("comment")}</h6>
                              <p>{items?.orderClaimDetails?.comment}</p>
                            </div>
                          </td> */}
                          <td colspan="1">
                            <div>
                              <h6>{locale("claimQuantity")}</h6>
                              <p>{items?.orderClaimDetails?.claimQuantity ? items?.orderClaimDetails?.claimQuantity : locale("na")}</p>
                            </div>
                          </td>
                          {items?.requestType !== 'PickUp' &&
                            <td colspan="1">
                              <div>
                                <h6>{locale("claimQuality")}</h6>
                                <p>{items?.orderClaimDetails?.claimQuality ? items?.orderClaimDetails?.claimQuality : locale("na")}</p>
                              </div>
                            </td>
                          }
                          {/* <td colspan="4">
                            <div>
                              <h6>{locale("picture")}</h6>
                              {items?.orderClaimDetails?.files ? defaultAttachedSpectFiles(items?.orderClaimDetails?.files) : <p>{locale("na")}</p>}
                            </div>
                          </td> */}
                        </>
                      }
                      {props.orderType === 'whiteSpace' && <td colspan="1">
                      </td>}
                    </tr>
                  </>
                }
              </>
            ))}
          </tbody>
        </Table>
        {props?.tableDataList?.orderLists?.length === 0 &&
          <div style={{ textAlign: 'center', padding: '12px' }}>{locale("noRecordsFound")}</div>}
      </TableContainer>

      <CommentBoxModal
        isOpen={commentModal}
        toggle={commentToggleModal}
        title=""
        content={locale("cancelOrderConfirmation")}
        onClickHander={(val) => {
          if (val === "no") {
          }
          else {
            if (val) {
              props.cancelOrderCallback(getItem, val)
            }
          }
        }}
        link="/"
      />

      <MixPalletDetailsModal
        isOpen={mixModalOpen}
        toggle={() => setMixModalOpen(!mixModalOpen)}
        orderData={selectedMixOrder}
        loggedUserCountry={userCountry}
      />
    </>
  );
};

export default AccordionTable;
